import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useSound } from 'react-sounds';
import { Button, Dialog, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconInfoCircle } from '@tabler/icons-react';
import { useUserStore } from '@/shared/stores/userStore';
import { useTranslation } from '@/i18n/client';

export function SupportDialog() {
  const { t, lng } = useTranslation('dialog');
  const soundPopup = useSound('notification/popup').play;
  const { user } = useUserStore((state) => state);
  const [opened, { close, open }] = useDisclosure(false);
  const path = usePathname();
  const { push } = useRouter();

  useEffect(
    () => {
      if (!opened && !path.includes('/cabinet') && user && user.support.length > 0) {
        soundPopup();
        open();
      }
      if (opened && (path.includes('/cabinet') || (user && user.support.length === 0))) {
        close();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user],
  );

  useEffect(
    () => {
      if (opened && path.includes('/cabinet')) {
        close();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [path],
  );

  return (
    <Dialog opened={opened} withCloseButton onClose={close} size='lg' radius='md'>
      <Flex align='center' gap={5}>
        <IconInfoCircle size={18} style={{ display: 'inline-block' }} color='rgb(180, 180, 250)' />
        <Text size='sm' fw={500} style={{ display: 'inline-block' }} c='rgb(180, 180, 250)'>
          {t('support.title')}
        </Text>
      </Flex>
      <Text size='md' my='sm' fw={500}>
        {t('support.description')}
      </Text>
      <Flex align='flex-end' style={{ position: 'relative' }}>
        <Button style={{ marginLeft: 'auto' }} onClick={() => push(`/${lng}/cabinet/support`)}>
          {t('support.button')}
        </Button>
      </Flex>
    </Dialog>
  );
}

export default SupportDialog;
